export function validate(record) {
    const errors = [];

    if (!record.code || record.code.trim() === "") {
        errors.push({ field: 'code', message: 'O código do modal é obrigatório!' });
    }

    if (!record.name || record.name === "") {
        errors.push({ field: 'name', message: 'O nome do modal é obrigatório!' });
    }

    if (!record.transportType || record.transportType === "") {
        errors.push({ field: 'transportType', message: 'O tipo de transporte do modal é obrigatório!' });
    }

    if (!record.freightTableType || record.freightTableType === "") {
        errors.push({ field: 'freightTableType', message: 'O tipo da tabela de frete do modal é obrigatório!' });
    }

    const result = {
        ok: errors.length === 0,
        errors,
        record
    }

    return new Promise((resolve, reject) => {
        const action = result.ok ? resolve : reject;
        return action(result);
    })
}